// ======================================================================================================================= COMPARISON SLIDER
class ComparisonSlider {
    constructor(element) {
        this.slider = element;
        this.input = element.querySelector('.co-comparison-slider__input');
        this.isDragging = false;
        
        this.handleInput = this.handleInput.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        
        this.init();
    }
    
    init() {

        this.slider.style.touchAction = 'none';
        
        this.input.style.touchAction = 'auto';
        
        this.input.addEventListener('input', this.handleInput);
        this.input.addEventListener('keydown', this.handleKeyDown);
        
        this.slider.addEventListener('pointerdown', this.handlePointerDown);
        
        this.updatePosition(50);
    }
    
    updatePosition(percent) {
        const clamped = Math.max(0, Math.min(100, percent));
        
        this.slider.style.setProperty('--position', `${clamped}%`);
        
        this.input.value = clamped;
        this.input.setAttribute('aria-valuenow', Math.round(clamped));
        this.input.setAttribute('aria-valuetext', 
            `${Math.round(clamped)}% - showing ${clamped < 50 ? 'more of the after' : clamped > 50 ? 'more of the before' : 'equal parts of before and after'} image${clamped === 50 ? 's' : ''}`
        );
    }
    
    handleInput(e) {
        this.updatePosition(parseFloat(e.target.value));
    }
    
    handlePointerDown(e) {

        if (e.target === this.input) return;
        
        e.preventDefault();
        
        this.isDragging = true;
        
        const smoother = window.scrollSmootherManager?.get();
        if (smoother) {
            smoother.paused(true);
        }
        
        this.slider.setPointerCapture(e.pointerId);
        
        this.slider.addEventListener('pointermove', this.handlePointerMove);
        this.slider.addEventListener('pointerup', this.handlePointerUp);
        this.slider.addEventListener('pointercancel', this.handlePointerUp);
        
        this.updateFromPointer(e);
    }
    
    handlePointerMove(e) {
        if (!this.isDragging) return;
        
        if (!this.rafId) {
            this.rafId = requestAnimationFrame(() => {
                this.updateFromPointer(e);
                this.rafId = null;
            });
        }
    }
    
    handlePointerUp(e) {
        this.isDragging = false;
        this.slider.releasePointerCapture(e.pointerId);
        
        const smoother = window.scrollSmootherManager?.get();
        if (smoother) {
            smoother.paused(false);
        }
        
        this.slider.removeEventListener('pointermove', this.handlePointerMove);
        this.slider.removeEventListener('pointerup', this.handlePointerUp);
        this.slider.removeEventListener('pointercancel', this.handlePointerUp);
        
        if (this.rafId) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
        }
    }
    
    updateFromPointer(e) {
        const rect = this.slider.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const percent = (x / rect.width) * 100;
        this.updatePosition(percent);
    }
    
    handleKeyDown(e) {
        const step = e.shiftKey ? 10 : 1;
        let newValue = parseFloat(this.input.value);
        
        switch (e.key) {
            case 'ArrowLeft':
            case 'ArrowDown':
                newValue -= step;
                e.preventDefault();
                break;
            case 'ArrowRight':
            case 'ArrowUp':
                newValue += step;
                e.preventDefault();
                break;
            case 'Home':
                newValue = 0;
                e.preventDefault();
                break;
            case 'End':
                newValue = 100;
                e.preventDefault();
                break;
            default:
                return;
        }
        
        this.updatePosition(newValue);
    }
    
    destroy() {
        this.input.removeEventListener('input', this.handleInput);
        this.input.removeEventListener('keydown', this.handleKeyDown);
        this.slider.removeEventListener('pointerdown', this.handlePointerDown);
    }
}

document.querySelectorAll('.co-comparison-slider').forEach(slider => {
    new ComparisonSlider(slider);
});
// ======================================================================================================================= ACCORDION
(function() {
    const DEFAULT_OPEN_INDEX = 1;
    const ANIMATION_DURATION = 400;

    const container = document.querySelector('[data-accordion-container-steps]');
    if (!container) return;

    const triggers = container.querySelectorAll('[data-accordion-trigger]');
    const panels = container.querySelectorAll('[data-accordion-panel]');
    const images = document.querySelectorAll('[data-accordion-image]');

    function refreshScroll() {
        if (window.scrollSmootherManager) {
            window.scrollSmootherManager.refresh();
        }
    }

    function openAccordion(trigger, panel, image, instant = false) {
        trigger.setAttribute('aria-expanded', 'true');
        trigger.parentElement.classList.add('is-active');
        
        if (image) image.classList.add('is-active');

        if (instant) {
            panel.classList.add('is-open');
            panel.style.height = 'auto';
            refreshScroll();
            return;
        }

        panel.style.height = 'auto';
        const targetHeight = panel.scrollHeight;
        panel.style.height = '0';

        panel.offsetHeight;

        requestAnimationFrame(() => {
            panel.style.height = targetHeight + 'px';
            panel.classList.add('is-open');
        });

        setTimeout(() => {
            if (panel.classList.contains('is-open')) {
                panel.style.height = 'auto';
                refreshScroll(); 
            }
        }, ANIMATION_DURATION);
    }

    function closeAccordion(trigger, panel, image, instant = false) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.parentElement.classList.remove('is-active');
        
        if (image) image.classList.remove('is-active');

        if (instant) {
            panel.classList.remove('is-open');
            panel.style.height = '0';
            refreshScroll();
            return;
        }

        panel.style.height = panel.scrollHeight + 'px';
        panel.classList.add('is-closing');

        panel.offsetHeight;

        requestAnimationFrame(() => {
            panel.style.height = '0';
        });

        setTimeout(() => {
            panel.classList.remove('is-open', 'is-closing');
            refreshScroll(); 
        }, ANIMATION_DURATION);
    }

    function setActiveAccordion(index) {
        triggers.forEach((trigger, i) => {
            const panel = panels[i];
            const image = images[i];
            const triggerIndex = trigger.dataset.accordionTrigger;

            if (triggerIndex === index) {
                const isCurrentlyExpanded = trigger.getAttribute('aria-expanded') === 'true';
                if (!isCurrentlyExpanded) {
                    openAccordion(trigger, panel, image);
                }
            } else if (trigger.getAttribute('aria-expanded') === 'true') {
                closeAccordion(trigger, panel, image);
            }
        });
    }

    if (DEFAULT_OPEN_INDEX && DEFAULT_OPEN_INDEX > 0) {
        const defaultTrigger = container.querySelector(`[data-accordion-trigger="${DEFAULT_OPEN_INDEX}"]`);
        const defaultPanel = container.querySelector(`[data-accordion-panel="${DEFAULT_OPEN_INDEX}"]`);
        const defaultImage = document.querySelector(`[data-accordion-image="${DEFAULT_OPEN_INDEX}"]`);
        
        if (defaultTrigger && defaultPanel) {
            openAccordion(defaultTrigger, defaultPanel, defaultImage, true);
        }
    }

    triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            setActiveAccordion(trigger.dataset.accordionTrigger);
        });
    });

    container.addEventListener('keydown', (e) => {
        const trigger = e.target.closest('[data-accordion-trigger]');
        if (!trigger) return;

        const triggerArray = Array.from(triggers);
        const currentIndex = triggerArray.indexOf(trigger);
        let newIndex;

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                newIndex = (currentIndex + 1) % triggerArray.length;
                triggerArray[newIndex].focus();
                break;
            case 'ArrowUp':
                e.preventDefault();
                newIndex = (currentIndex - 1 + triggerArray.length) % triggerArray.length;
                triggerArray[newIndex].focus();
                break;
            case 'Home':
                e.preventDefault();
                triggerArray[0].focus();
                break;
            case 'End':
                e.preventDefault();
                triggerArray[triggerArray.length - 1].focus();
                break;
        }
    });
})();
// ======================================================================================================================= ACCORDION FAQ
(function() {
    const DEFAULT_OPEN_INDEX = 1;
    const ANIMATION_DURATION = 400;

    const container = document.querySelector('[data-accordion-container-faq]');
    if (!container) return;

    const triggers = container.querySelectorAll('[data-accordion-trigger]');
    const panels = container.querySelectorAll('[data-accordion-panel]');

    function refreshScroll() {
        if (window.scrollSmootherManager) {
            window.scrollSmootherManager.refresh();
        }
    }

    function openAccordion(trigger, panel, instant = false) {
        trigger.setAttribute('aria-expanded', 'true');
        trigger.parentElement.classList.add('is-active');

        if (instant) {
            panel.classList.add('is-open');
            panel.style.height = 'auto';
            refreshScroll();
            return;
        }

        panel.style.height = 'auto';
        const targetHeight = panel.scrollHeight;
        panel.style.height = '0';

        panel.offsetHeight;

        requestAnimationFrame(() => {
            panel.style.height = targetHeight + 'px';
            panel.classList.add('is-open');
        });

        setTimeout(() => {
            if (panel.classList.contains('is-open')) {
                panel.style.height = 'auto';
                refreshScroll();
            }
        }, ANIMATION_DURATION);
    }

    function closeAccordion(trigger, panel, instant = false) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.parentElement.classList.remove('is-active');

        if (instant) {
            panel.classList.remove('is-open');
            panel.style.height = '0';
            refreshScroll();
            return;
        }

        panel.style.height = panel.scrollHeight + 'px';
        panel.classList.add('is-closing');

        panel.offsetHeight;

        requestAnimationFrame(() => {
            panel.style.height = '0';
        });

        setTimeout(() => {
            panel.classList.remove('is-open', 'is-closing');
            refreshScroll();
        }, ANIMATION_DURATION);
    }

    function toggleAccordion(trigger, panel) {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
            closeAccordion(trigger, panel);
        } else {
            openAccordion(trigger, panel);
        }
    }

    if (DEFAULT_OPEN_INDEX && DEFAULT_OPEN_INDEX > 0) {
        const defaultTrigger = container.querySelector(`[data-accordion-trigger="${DEFAULT_OPEN_INDEX}"]`);
        const defaultPanel = container.querySelector(`[data-accordion-panel="${DEFAULT_OPEN_INDEX}"]`);
        
        if (defaultTrigger && defaultPanel) {
            openAccordion(defaultTrigger, defaultPanel, true);
        }
    }

    triggers.forEach((trigger, i) => {
        trigger.addEventListener('click', () => {
            toggleAccordion(trigger, panels[i]);
        });
    });

    container.addEventListener('keydown', (e) => {
        const trigger = e.target.closest('[data-accordion-trigger]');
        if (!trigger) return;

        const triggerArray = Array.from(triggers);
        const currentIndex = triggerArray.indexOf(trigger);
        let newIndex;

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                newIndex = (currentIndex + 1) % triggerArray.length;
                triggerArray[newIndex].focus();
                break;
            case 'ArrowUp':
                e.preventDefault();
                newIndex = (currentIndex - 1 + triggerArray.length) % triggerArray.length;
                triggerArray[newIndex].focus();
                break;
            case 'Home':
                e.preventDefault();
                triggerArray[0].focus();
                break;
            case 'End':
                e.preventDefault();
                triggerArray[triggerArray.length - 1].focus();
                break;
        }
    });
})();
// ======================================================================================================================= TABS
class Tabs {
  constructor(triggersContainer, options = {}) {
    this.options = { autoActivate: true, loop: true, onChange: null, ...options };
    
    const id = triggersContainer.dataset.tabs;
    const panelsContainer = document.querySelector(`[data-tabs-panels="${id}"]`);
    
    this.tabs = [...triggersContainer.querySelectorAll('[role="tab"]')];
    this.panels = this.tabs.map(tab => 
      panelsContainer?.querySelector(`#${tab.getAttribute('aria-controls')}`) ||
      document.getElementById(tab.getAttribute('aria-controls'))
    );
    
    this.activeIndex = Math.max(0, this.tabs.findIndex(t => t.getAttribute('aria-selected') === 'true'));
    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', e => { e.preventDefault(); this.activate(i, true); });
      tab.addEventListener('keydown', e => this.onKeyDown(e));
    });

    this.panels.forEach(panel => {
      panel?.addEventListener('keydown', e => {
        if (e.key === 'Escape') this.tabs[this.activeIndex]?.focus();
      });
    });
  }

  onKeyDown(e) {
    const actions = {
      ArrowLeft: () => this.focusOffset(-1),
      ArrowRight: () => this.focusOffset(1),
      Home: () => this.focusEnd(-1),
      End: () => this.focusEnd(1),
      Enter: () => this.activate(this.tabs.indexOf(document.activeElement), true),
      ' ': () => this.activate(this.tabs.indexOf(document.activeElement), true)
    };
    if (actions[e.key]) { e.preventDefault(); actions[e.key](); }
  }

  isDisabled(i) {
    const t = this.tabs[i];
    return t?.disabled || t?.getAttribute('aria-disabled') === 'true';
  }

  focusOffset(dir) {
    let i = this.tabs.indexOf(document.activeElement) + dir;
    const len = this.tabs.length;
    
    for (let n = 0; n < len; n++) {
      if (i < 0) i = this.options.loop ? len - 1 : 0;
      if (i >= len) i = this.options.loop ? 0 : len - 1;
      if (!this.isDisabled(i)) break;
      i += dir;
    }
    
    this.focusTab(i);
  }

  focusEnd(dir) {
    let i = dir < 0 ? 0 : this.tabs.length - 1;
    while (this.isDisabled(i) && i >= 0 && i < this.tabs.length) i -= dir;
    this.focusTab(i);
  }

  focusTab(i) {
    if (this.isDisabled(i)) return;
    this.tabs[i]?.focus();
    if (this.options.autoActivate) this.activate(i);
  }

  activate(i, focus = false) {
    if (this.isDisabled(i) || i === this.activeIndex) return;
    
    const prev = this.activeIndex;
    
    this.tabs.forEach((t, idx) => {
      const active = idx === i;
      t.setAttribute('aria-selected', active);
      t.setAttribute('tabindex', active ? '0' : '-1');
    });

    this.panels.forEach((p, idx) => {
      if (!p) return;
      idx === i ? p.removeAttribute('hidden') : p.setAttribute('hidden', '');
    });

    this.activeIndex = i;
    if (focus) this.tabs[i]?.focus();

    this.options.onChange?.({ prev, index: i, tab: this.tabs[i], panel: this.panels[i] });
  }

  goTo(i) { this.activate(i, true); }
  next() { this.focusOffset(1); this.activate(this.tabs.indexOf(document.activeElement), true); }
  prev() { this.focusOffset(-1); this.activate(this.tabs.indexOf(document.activeElement), true); }
}

const initTabs = () => document.querySelectorAll('[data-tabs]').forEach(el => el._tabs ||= new Tabs(el));
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initTabs) : initTabs();

window.Tabs = Tabs;

// ======================================================================================================================= POPUP
// class Popup {
//     constructor() {
//     this.activePopup = null;
//     this.init();
//     }
//     init() {
//     document.querySelectorAll('[data-popup-target]').forEach(trigger => {
//         trigger.addEventListener('click', (e) => {
//         const popupId = e.currentTarget.getAttribute('data-popup-target');
//         this.open(popupId);
//         });
//     });
//     document.querySelectorAll('.co-popup-close').forEach(closeBtn => {
//         closeBtn.addEventListener('click', () => this.close());
//     });
//     document.querySelectorAll('.co-popup-overlay').forEach(overlay => {
//         overlay.addEventListener('click', (e) => {
//         if (e.target === overlay) {
//             this.close();
//         }
//         });
//     });
//     document.addEventListener('keydown', (e) => {
//         if (e.key === 'Escape' && this.activePopup) {
//         this.close();
//         }
//     });
//     }
//     open(popupId) {
//     const popup = document.getElementById(popupId);
//     if (popup) {
//         popup.classList.add('active');
//         this.activePopup = popup;
//         document.body.style.overflow = 'hidden';
//     }
//     }
//     close() {
//     if (this.activePopup) {
//         this.activePopup.classList.remove('active');
//         this.activePopup = null;
//         document.body.style.overflow = '';
//     }
//     }
// }
// const popup = new Popup();
// ======================================================================================================================= REVIEWS
// (function() {
//   'use strict';
  
//   function setEqualHeights() {
//     const titleElements = document.querySelectorAll('.co-home-8-cell-frame');
    
//     if (titleElements.length === 0) return;
    
//     titleElements.forEach(el => el.style.height = 'auto');
    
//     let maxHeight = 0;
//     titleElements.forEach(el => {
//       const height = el.offsetHeight;
//       if (height > maxHeight) {
//         maxHeight = height;
//       }
//     });
    
//     titleElements.forEach(el => {
//       el.style.height = maxHeight + 'px';
//     });
//   }

//   const flkty = new Flickity('.co-home-8-slider', {
//     cellAlign: 'left',
//     contain: true,
//     prevNextButtons: false,
//     pageDots: false,
//     arrowShape: '',
//     // selectedAttraction: 0.01,
//     // friction: 0.2,
//     on: {
//       ready: function() {
//         setEqualHeights();
//       },
//       settle: function() {
//         setEqualHeights();
//       }
//     }
//   });
  
//   window.addEventListener('resize', function() {
//     flkty.resize();
//     setEqualHeights();
//   });
// })();

// ======================================================================================================================= SECTION 7 WORD VERTICAL LOOP
(function() {
  const CONFIG = {
    pause: 2000,
    animationSpeed: 500,
    autoWidth: false
  };

  class WordSwitcher {
    constructor(element) {
      this.container = element;
      this.words = Array.from(element.querySelectorAll('.co-home-7-1-word-switcher__word'));
      this.wordCount = this.words.length;
      this.currentIndex = 0;
      this.resizeTimeout = null;

      if (this.wordCount > 1) {
        this.init();
      }
    }

    init() {
      this.container.style.setProperty('--word-switcher-animation-speed', `${CONFIG.animationSpeed}ms`);
      this.autoWidth = this.container.dataset.wordSwitcherAutoWidth !== undefined
        ? this.container.dataset.wordSwitcherAutoWidth !== 'false'
        : CONFIG.autoWidth;

      if (this.autoWidth) {
        this.setContainerWidth();
      }

      this.words[0].classList.add('is-active');
      this.startLoop();

      if (this.autoWidth) {
        this.bindResize();
      }
    }

    bindResize() {
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => this.setContainerWidth(), 100);
      });
    }

    setContainerWidth() {
      const containerEl = this.container.querySelector('.co-home-7-1-word-switcher__container');
      let maxWidth = 0;

      this.words.forEach(word => {
        word.style.transition = 'none';
        word.style.transform = 'translateY(0)';
        word.style.position = 'relative';
        word.style.visibility = 'hidden';

        word.offsetHeight;
        const width = word.offsetWidth;
        if (width > maxWidth) maxWidth = width;

        word.style.transform = '';
        word.style.position = '';
        word.style.visibility = '';
        word.offsetHeight;
        word.style.transition = '';
      });

      containerEl.style.width = `${maxWidth}px`;
    }

    startLoop() {
      setInterval(() => this.next(), CONFIG.pause);
    }

    next() {
      const currentWord = this.words[this.currentIndex];
      const nextIndex = (this.currentIndex + 1) % this.wordCount;
      const nextWord = this.words[nextIndex];

      currentWord.classList.remove('is-active');
      currentWord.classList.add('is-exiting');
      nextWord.classList.add('is-active');

      setTimeout(() => {
        currentWord.style.transition = 'none';
        currentWord.classList.remove('is-exiting');
        currentWord.offsetHeight;
        currentWord.style.transition = '';
      }, CONFIG.animationSpeed);

      this.currentIndex = nextIndex;
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-word-switcher]').forEach(function(el) {
      new WordSwitcher(el);
    });
  });
})();

// ======================================================================================================================= SECTION 2 HEIGHT
(() => {
  const els = document.querySelectorAll('.co-home-2-review-text');
  if (els.length < 2) return;

  const mq = window.matchMedia('(min-width: 601px)');

  const sync = () => {
    if (!mq.matches) {
      els.forEach(el => el.style.height = '');
      return;
    }
    els.forEach(el => el.style.height = '');
    const max = Math.max(...[...els].map(el => el.offsetHeight));
    els.forEach(el => el.style.height = `${max}px`);
  };

  sync();
  mq.addEventListener('change', sync);
  new ResizeObserver(sync).observe(els[0].parentElement);
})();

(function() {
  'use strict';

  const config = {
    sourceSelector: '[data-height-source]',
    targetSelector: '[data-height-target]',
    cssVariable: '--co-dynamic-height',
    debounceDelay: 150
  };

  let resizeTimeout = null;
  let resizeObserver = null;

  function updateHeight() {
    const source = document.querySelector(config.sourceSelector);
    const target = document.querySelector(config.targetSelector);

    if (!source || !target) return;

    const height = source.offsetHeight;
    target.style.setProperty(config.cssVariable, `${height}px`);
  }

  function debouncedUpdate() {
    if (resizeTimeout) {
      cancelAnimationFrame(resizeTimeout);
    }
    resizeTimeout = requestAnimationFrame(updateHeight);
  }

  function init() {
    updateHeight();

    const source = document.querySelector(config.sourceSelector);
    if (source && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(debouncedUpdate);
      resizeObserver.observe(source);
    }

    window.addEventListener('resize', debouncedUpdate, { passive: true });
  }

  function destroy() {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
    window.removeEventListener('resize', debouncedUpdate);
    if (resizeTimeout) {
      cancelAnimationFrame(resizeTimeout);
      resizeTimeout = null;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.DynamicHeight = {
    update: updateHeight,
    destroy: destroy,
    init: init
  };
})();

// ======================================================================================================================= MOUSEOVER
class MouseFollower {
  constructor(options = {}) {
    this.ease = options.ease ?? 0.1;
    this.threshold = options.threshold ?? 0.1;
    this.activeClass = options.activeClass ?? 'is-active';
    this.instances = new Map();
    this.activeInstances = new Set();
    this.rafId = null;

    this.init();
  }

  init() {
    document.querySelectorAll('[data-mouse-parent]').forEach(parent => {
      const target = parent.querySelector('[data-mouse-target]');
      if (!target) return;

      const instance = {
        parent,
        target,
        bounds: null,
        offset: { x: 0, y: 0 },
        mouse: { x: 0, y: 0 },
        current: { x: 0, y: 0 },
        isHovering: false,
        isOverButton: false
      };

      this.instances.set(parent, instance);
      this.bindEvents(instance);
    });
  }

  getTargetOffset(instance) {
    const { parent, target } = instance;
    const parentRect = parent.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();

    const parentCenterX = parentRect.left + parentRect.width / 2;
    const parentCenterY = parentRect.top + parentRect.height / 2;
    const targetCenterX = targetRect.left + targetRect.width / 2;
    const targetCenterY = targetRect.top + targetRect.height / 2;

    return {
      x: targetCenterX - parentCenterX,
      y: targetCenterY - parentCenterY
    };
  }

  bindEvents(instance) {
    const { parent, target } = instance;
    const buttons = parent.querySelectorAll('[data-mouse-button]');

    parent.addEventListener('mouseenter', () => {
      instance.bounds = parent.getBoundingClientRect();
      instance.offset = this.getTargetOffset(instance);
      instance.isHovering = true;
      this.activeInstances.add(instance);
      this.startLoop();

      if (!instance.isOverButton) {
        parent.classList.add(this.activeClass);
        target.classList.add(this.activeClass);
      }
    });

    parent.addEventListener('mousemove', (e) => {
      if (!instance.bounds) return;

      const centerX = instance.bounds.left + instance.bounds.width / 2;
      const centerY = instance.bounds.top + instance.bounds.height / 2;

      instance.mouse.x = e.clientX - centerX - instance.offset.x;
      instance.mouse.y = e.clientY - centerY - instance.offset.y;
    });

    parent.addEventListener('mouseleave', () => {
      instance.isHovering = false;
      instance.mouse.x = 0;
      instance.mouse.y = 0;
      parent.classList.remove(this.activeClass);
      target.classList.remove(this.activeClass);
    });

    buttons.forEach(button => {
      button.addEventListener('mouseenter', () => {
        instance.isOverButton = true;
        parent.classList.remove(this.activeClass);
        target.classList.remove(this.activeClass);
      });

      button.addEventListener('mouseleave', () => {
        instance.isOverButton = false;
        if (instance.isHovering) {
          parent.classList.add(this.activeClass);
          target.classList.add(this.activeClass);
        }
      });
    });
  }

  startLoop() {
    if (this.rafId) return;
    this.tick();
  }

  stopLoop() {
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  tick() {
    this.activeInstances.forEach(instance => {
      const { target, mouse, current } = instance;

      current.x += (mouse.x - current.x) * this.ease;
      current.y += (mouse.y - current.y) * this.ease;

      target.style.transform = `translate3d(${current.x}px, ${current.y}px, 0)`;

      const isSettled =
        !instance.isHovering &&
        Math.abs(current.x) < this.threshold &&
        Math.abs(current.y) < this.threshold;

      if (isSettled) {
        current.x = 0;
        current.y = 0;
        target.style.transform = 'translate3d(0, 0, 0)';
        this.activeInstances.delete(instance);
      }
    });

    if (this.activeInstances.size > 0) {
      this.rafId = requestAnimationFrame(() => this.tick());
    } else {
      this.rafId = null;
    }
  }

  refresh() {
    this.instances.forEach(instance => {
      if (instance.isHovering) {
        instance.bounds = instance.parent.getBoundingClientRect();
        instance.offset = this.getTargetOffset(instance);
      }
    });
  }

  destroy() {
    this.stopLoop();
    this.instances.forEach(({ parent, target }) => {
      parent.classList.remove(this.activeClass);
      target.classList.remove(this.activeClass);
    });
    this.instances.clear();
    this.activeInstances.clear();
  }
}

const follower = new MouseFollower({
  ease: 0.1,
  threshold: 0.1,
  activeClass: 'is-active'
});

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => follower.refresh(), 100);
});